import { GroupModelAPI } from '../../../../models';
import { getGroupListadapter } from '../../Adapters/groups/Groups.adapter';
import { requests } from '../apiAgent';

export const GroupAPI = {
    getGroups: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/groups')
            .then((response: GroupModelAPI[]) => getGroupListadapter(response));
    },
};
